import type { FC } from 'react';
import { ModalContainer, ModalHeader } from '@/utils/modal';
import { useApiHook } from '@/support/Hooks/api/useApiHook';
import { type TeamGlossary } from '@/model/Glosary.model';
import Loading from '@/components/Loading';
import BulkSamplesForm from './BulkCreateSamplesForm';
import type { MetadataItem } from '@/model/Metadata.model';
import type { BulkSamplesFormData } from '@/model/Sample.model';
import { useFetchCollection } from '@/support/Hooks/fetch';

interface BulkCreateSamplesProps {
  closeModal: () => void;
  handleCallback: (formData: BulkSamplesFormData, metadata?: Array<MetadataItem>) => void;
}

const BulkCreateSamples: FC<BulkCreateSamplesProps> = ({ closeModal, handleCallback }) => {
  const { response: samplesResponse, loading: sampleTypesLoading } = useApiHook({
    endpoint: 'GET /api/v1/team-glossary',
    path: undefined,
    query: {
      group: 'samples',
      perPage: -1,
      filterType: 'and',
      'filters[]': ['status|eq|active'],
      order: 'asc',
      sort: 'title',
    },
    options: { onError: { toast: false, slug: 'bulk-samples-load' } },
  });
  const sampleTypeOptions = (samplesResponse?.body as { data: Array<TeamGlossary> })?.data ?? [];

  const { collection: sampleMetadata, collectionLoading: metadataLoading } = useFetchCollection<MetadataItem>({
    collectionType: 'metadataGlossaries',
    queryParams: {
      filter_type: 'sample_meta',
    },
  });

  return (
    <ModalContainer size="narrow">
      <ModalHeader title="Collect Samples" closeModal={closeModal} className="pa3 bb b--moon-gray w-100" />
      {sampleTypesLoading || metadataLoading ? (
        <div className="w-100 h-100">
          <Loading />
        </div>
      ) : (
        <BulkSamplesForm
          sampleMetadata={sampleMetadata}
          sampleTypeOptions={sampleTypeOptions}
          handleCallback={handleCallback}
          closeModal={closeModal}
        />
      )}
    </ModalContainer>
  );
};

export default BulkCreateSamples;
